<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
	.tag-btn {
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>用户管理</el-breadcrumb-item>
			<el-breadcrumb-item>头像审核</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>状态：</div>
				<el-select size="mini" v-model="searchForm.is_agent" placeholder="全部类型" style="width: 100px;">
					<el-option v-for="item in status_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;</div>
				<el-button size="mini" type="primary" @click="getData()">刷新</el-button>
				
				<el-button size="mini" type="danger" @click="allAgree()">全部同意</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="序号" align="center" width="100"></el-table-column>

				<el-table-column prop="shop_name" label="店铺名" align="center">
					<template slot-scope="scope">
						{{scope.row.shop_name}}({{scope.row.sid}})
					</template>
				</el-table-column>
				
				<el-table-column prop="username" label="用户名" align="center">
					<template slot-scope="scope">
						{{scope.row.username}}({{scope.row.uid}})
					</template>
				</el-table-column>
				
				<el-table-column prop="oldAvatar" label="旧头像" align="center">
					<template slot-scope="scope">
						<el-image :src="scope.row.oldAvatar" :preview-src-list="[scope.row.oldAvatar]" lazy style="border-radius: 50px; width: 50px; height: 50px;"></el-image>
					</template>
				</el-table-column>
				
				<el-table-column prop="newAvatar" label="新头像" align="center">
					<template slot-scope="scope">
						<el-image :src="scope.row.newAvatar" :preview-src-list="[scope.row.newAvatar]" lazy style="border-radius: 50px; width: 50px; height: 50px;"></el-image>
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="审核状态" align="center" width="140">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status == 0" size="mini">待审核</el-tag>
						<el-tag type="danger" v-if="scope.row.status == 1" size="mini">已通过</el-tag>
						<el-tag type="info" v-if="scope.row.status == 2" size="mini">已驳回</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="createTime" label="提交时间" width="200" align="center">
				</el-table-column>
				<el-table-column prop="status" label="操作" fixed="right" width="240" align="center">
					<template slot-scope="scope">
						<el-tag class='tag-btn' v-if="scope.row.status==0" style="margin-right: 10px;" size="mini"  @click="conformApply(scope)">审核</el-tag>
						<el-tag class='tag-btn' type="danger" style="margin-right: 10px;" size="mini"  @click="deleteFunc(scope)">刪除</el-tag>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
	</div> 
</template>

<script>
	export default {
		components:{
		},
		computed:{
		},
		data(){
			return {
				status_list:[{label:'全部', value:''},{label:'待审核', value:'0'}, {label:'已同意', value:'1'}, {label:'已拒绝', value:'2'}],
				checkInfo:{},
				checkShow:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:20,
				searchForm:{
					keyword:'',
					is_agent:'',
					online:'',
					endTime:'',
					pid:'',
				}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			allAgree(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '处理中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/User/allAvatarAgree", {}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.getData();
						return _this.$message({
							 message: '处理成功',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			confirmUnInfo(scope){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '审核中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/User/confirmAvatarApply", {id:scope.row.id}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: '审核成功',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			confirmDelete(scope){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '删除中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/User/deleteAvatarApply", {id:scope.row.id}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.tableData.splice(scope.$index, 1);
						return _this.$message({
							 message: '删除成功',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			deleteFunc(scope){
					let _this = this;
					_this.confirmDelete(scope);
					return;
					this.$confirm('是否确认删除此申请记录？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						_this.confirmDelete(scope);
					}).catch(() => {      
					});
			},
			conformApply(scope){
				let _this = this;
				_this.confirmUnInfo(scope);
				return;
				this.$confirm('是否确认审核通过？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.confirmUnInfo(scope);
				}).catch(() => {      
				});
			},
			reset(){
				this.searchForm = {
					keyword:'',
					is_agent:'',
					online:'',
					endTime:'',
					pid:'',
				};
			},
			calcDays(_time){
				if(_time == 0) return '-';
				let _nowtime = new Date().getTime();
				let _subTime =  _time * 1000 - _nowtime;
				let _days = _subTime / 1000 / 60 / 60 / 24;
				return _days.toFixed(2) + '天';
			},
			handleClose(){
				this.pushShow = false;
				this.walletShow = false;
				this.editShow = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/User/getAvatarApply", {page:this.currentPage, limit:this.limit, ...this.searchForm}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

